module.exports = __webpack_public_path__ + "img/3.38af2f3a.svg";